export default {
    salutation: "Anrede",
    gender: "Geschlecht",
    sex: "Geschlecht",
    diverseSalutation: "Divers",
    genderless: "Keine Angabe",
    noneSalutation: "Keine Anrede",
    allTakenFemale: "(Für diese Veranstaltung sind bereits alle Plätze für weiblichen Teilnehmer vergeben.)",
    allTakenMale: "(Für diese Veranstaltung sind bereits alle Plätze für männlichen Teilnehmer vergeben.)",
    contactType: "Kontaktart",
    person: "Privatperson",
    organisation: "Organisation",
    organisationName: "Name der Organisation",
    title: "Titel",
    acadTitle: "Akad. Titel",
    noTitle: "Kein Titel",
    firstname: "Vorname",
    lastname: "Nachname",
    vatId: "USt-ID",
    toTheAttention: "Zu Händen",
    birthday: "Geburtsdatum",
    dateWarning: "Ihr Browser scheint kein standardisiertes Datumsformat zu unterstützen. Dies kann zu Problemen bei der " +
        "Anmeldung führen. Bitte geben Sie das Datum im Format TT.MM.JJJJ oder JJJJ-MM-DD ein.",

    addressType: "Adressart",
    country: "Land",
    zip: "PLZ",
    pleaseInputZipFirst: "Bitte zuerst PLZ eingeben",
    pleaseInputCityFirst: "Bitte zuerst einen Ort auswählen",
    pleaseInputStreetFirst: "Bitte zuerst eine Straße auswählen",

    city: "Ort",
    chooseCity: "Ort wählen",
    noCitiesFound: "Es konnten keine Orte gefunden werden!",
    loadCities: "Lade Orte...",

    street: "Straße",
    chooseStreet: "Straße wählen",
    loadStreets: "Lade Straßen...",
    noStreetsFound: "Es konnten keine Straßen gefunden werden!",

    houseNumber: "Hausnummer",
    postboxNumber: "Postfachnummer",

    addressAdditional: "Adresszusatz",

    isPostbox: "Adresse ist ein Postfach",

    phone: "Telefonnummer",
    email: "E-Mail",

    listOfParticipantsAgreement: "Keine Teilnehmer hinzugefügt|" +
        "Meine Adresse darf auf einer Teilnehmerliste erscheinen (ein JA erleichtert die Organisation, z. B. für Fahrgemeinschaften).|" +
        "Unsere Adressen dürfen auf einer Teilnehmerliste erscheinen (ein JA erleichtert die Organisation, z. B. für Fahrgemeinschaften).",
    queryListOfParticipantsAgreement: "Meine Adresse darf auf einer Teilnehmerliste erscheinen",
    queryListOfParticipantsAgreementInfo: "Ein JA erleichtert die Organisation, z. B. für Fahrgemeinschaften.",
    photosAgreement: "Einwilligung in die Veröffentlichung von Fotos",
    showFullText: "Vollständig anzeigen",
    ownResourcesAgreementName: "Bestätigung der eigenen Mittel",
    ownResourcesAgreement: "Ich bestätige, dass ich die Teilnahme an der Veranstaltung mit Mitteln bewirke, " +
        "die mir zur freien Verfügung stehen und mir dies von meinen Eltern oder Vormund (Sorgeberechtigten) genehmigt wurde.",

    'delete': "Entfernen",

    applyAddressFromParticipant: 'Anschrift von Teilnehmenden übernehmen',
    applyAddressFromParticipantSelectPlaceholder: 'Anschrift auswählen'
}
